import { LabelFieldConfig } from "./Label/Config.js";
import { LabelDisplay } from "./Label/Display.js";
import { InfoBlockFieldConfig } from "./InfoBlock/Config.js";
import { InfoBlockDisplay } from "./InfoBlock/Display.js";
import { DividerFieldConfig } from "./Divider/Config.js";
import { DividerDisplay } from "./Divider/Display.js";
import { DateTimeFieldForm } from "./DateTime/Form.js";
import { RadioFieldForm } from "./Radio/Form.js";
import { SelectFieldForm } from "./Select/Form.js";
import { TextareaFieldForm } from "./Textarea/Form.js";
import { CheckboxFieldForm } from "./Checkbox/Form.js";
import { RecordFieldForm } from "./Record/Form.js";
import { LocationFieldForm } from "./Location/Form.js";
import { UserFieldForm } from "./User/Form.js";
import { EventFieldForm } from "./Event/Form.js";
import { ReportFieldForm } from "./Report/Form.js";
import { FilesFieldForm } from "./Files/Form.js";
import { GeoCoordinatesFieldForm } from "./GeoCoordinates/Form.js";
import { TextFieldForm } from "./Text/Form.js";
import { DateTimeFieldConfig } from "./DateTime/Config.js";
import { DateTimeFieldDisplay } from "./DateTime/Display.js";
import { RadioFieldConfig } from "./Radio/Config.js";
import { RadioFieldDisplay } from "./Radio/Display.js";
import { SelectFieldConfig } from "./Select/Config.js";
import { SelectFieldDisplay } from "./Select/Display.js";
import { TextareaFieldConfig } from "./Textarea/Config.js";
import { TextareaFieldDisplay } from "./Textarea/Display.js";
import { CheckboxFieldConfig } from "./Checkbox/Config.js";
import { CheckboxFieldDisplay } from "./Checkbox/Display.js";
import { RecordFieldConfig } from "./Record/Config.js";
import { RecordFieldDisplay } from "./Record/Display.js";
import { LocationFieldConfig } from "./Location/Config.js";
import { LocationFieldDisplay } from "./Location/Display.js";
import { UserFieldConfig } from "./User/Config.js";
import { UserFieldDisplay } from "./User/Display.js";
import { EventFieldConfig } from "./Event/Config.js";
import { EventFieldDisplay } from "./Event/Display.js";
import { ReportFieldConfig } from "./Report/Config.js";
import { ReportFieldDisplay } from "./Report/Display.js";
import { FilesFieldConfig } from "./Files/Config.js";
import { FilesFieldDisplay } from "./Files/Display.js";
import { GeoCoordinatesFieldConfig } from "./GeoCoordinates/Config.js";
import { GeoCoordinatesFieldDisplay } from "./GeoCoordinates/Display.js";
import { TextFieldConfig } from "./Text/Config.js";
import { TextFieldDisplay } from "./Text/Display.js";
import { ActivityTypesFieldConfig } from "./ActivityTypes/Config.js";
import { ActivityTypesFieldDisplay } from "./ActivityTypes/Display.js";
import { ActivityTypesFieldForm } from "./ActivityTypes/Form.js";
import { GPSMediaFieldConfig } from "./GPSMedia/Config.js";
import { GPSMediaFieldDisplay } from "./GPSMedia/Display.js";
import { GPSMediaFieldForm } from "./GPSMedia/Form.js";
import { SignatureFieldConfig } from "./Signature/Config.js";
import { SignatureFieldDisplay } from "./Signature/Display.js";
import { SignatureFieldForm } from "./Signature/Form.js";
//#region src/modules/FormBuilder/components/Fields/index.ts
var formBuilderFieldsByType = {
	activitytypes: {
		Config: ActivityTypesFieldConfig,
		defaultOptions: {
			displayLabel: "Activity Types",
			formLabel: "Activity Types"
		},
		DisplayLayout: ActivityTypesFieldDisplay,
		FormLayout: ActivityTypesFieldForm,
		idPrefix: "activitytypes",
		sidebar: { label: "Activity Types" },
		type: "activitytypes"
	},
	checkbox: {
		Config: CheckboxFieldConfig,
		defaultOptions: {
			displayCheckedLabel: "Checkbox",
			displayUncheckedLabel: "",
			formLabel: "Checkbox"
		},
		DisplayLayout: CheckboxFieldDisplay,
		FormLayout: CheckboxFieldForm,
		idPrefix: "checkbox",
		sidebar: { label: "Checkbox" },
		type: "checkbox"
	},
	datetime: {
		Config: DateTimeFieldConfig,
		defaultOptions: {
			displayLabel: "Date / Time",
			formLabel: "Date / Time",
			mode: "datetime"
		},
		DisplayLayout: DateTimeFieldDisplay,
		FormLayout: DateTimeFieldForm,
		idPrefix: "datetime",
		sidebar: { label: "Date / Time" },
		type: "datetime"
	},
	divider: {
		Config: DividerFieldConfig,
		defaultOptions: {},
		DisplayLayout: DividerDisplay,
		FormLayout: DividerDisplay,
		idPrefix: "divider",
		sidebar: { label: "Divider" },
		type: "divider"
	},
	event: {
		Config: EventFieldConfig,
		defaultOptions: {
			displayLabel: "Events",
			formLabel: "Events"
		},
		DisplayLayout: EventFieldDisplay,
		FormLayout: EventFieldForm,
		idPrefix: "event",
		sidebar: { label: "Events" },
		type: "event"
	},
	files: {
		Config: FilesFieldConfig,
		defaultOptions: {
			displayLabel: "Files/Images/Video",
			formLabel: "Files/Images/Video",
			/** Default to allow multi-file  */
			multi: true,
			/** When true the user can only use in-app camera/video */
			noFilesAndGalleryPicker: false
		},
		DisplayLayout: FilesFieldDisplay,
		FormLayout: FilesFieldForm,
		idPrefix: "files",
		sidebar: { label: "Files/Images/Video Picker" },
		type: "files"
	},
	geocoordinates: {
		Config: GeoCoordinatesFieldConfig,
		defaultOptions: {
			displayLabel: "GPS Coordinates",
			formLabel: "GPS Coordinates"
		},
		DisplayLayout: GeoCoordinatesFieldDisplay,
		FormLayout: GeoCoordinatesFieldForm,
		idPrefix: "geocoordinates",
		sidebar: { label: "GPS Coordinates" },
		type: "geocoordinates"
	},
	gpsmedia: {
		Config: GPSMediaFieldConfig,
		defaultOptions: {
			displayLabel: "Photo/Video (GPS/Time)",
			formLabel: "Photo/Video (GPS/Time)"
		},
		DisplayLayout: GPSMediaFieldDisplay,
		FormLayout: GPSMediaFieldForm,
		idPrefix: "gpsmedia",
		sidebar: { label: "Photo/Video (GPS/Time)" },
		type: "gpsmedia"
	},
	infoblock: {
		Config: InfoBlockFieldConfig,
		defaultOptions: { body: "Enter information here..." },
		DisplayLayout: InfoBlockDisplay,
		FormLayout: InfoBlockDisplay,
		idPrefix: "infoblock",
		sidebar: { label: "Info Block" },
		type: "infoblock"
	},
	label: {
		Config: LabelFieldConfig,
		defaultOptions: { label: "Label" },
		DisplayLayout: LabelDisplay,
		FormLayout: LabelDisplay,
		idPrefix: "label",
		sidebar: { label: "Label" },
		type: "label"
	},
	location: {
		Config: LocationFieldConfig,
		defaultOptions: {
			displayLabel: "Locations",
			formLabel: "Locations"
		},
		DisplayLayout: LocationFieldDisplay,
		FormLayout: LocationFieldForm,
		idPrefix: "location",
		sidebar: { label: "Locations" },
		type: "location"
	},
	radio: {
		Config: RadioFieldConfig,
		defaultOptions: {
			displayLabel: "Option Group",
			formLabel: "Option Group",
			options: [
				{ label: "Yes" },
				{ label: "No" },
				{ label: "n/a" }
			]
		},
		DisplayLayout: RadioFieldDisplay,
		FormLayout: RadioFieldForm,
		idPrefix: "radio",
		sidebar: { label: "Option Group" },
		type: "radio"
	},
	record: {
		Config: RecordFieldConfig,
		defaultOptions: {
			displayLabel: "Records",
			formLabel: "Records",
			/** Default to allow multi-file  */
			multi: true
		},
		DisplayLayout: RecordFieldDisplay,
		FormLayout: RecordFieldForm,
		idPrefix: "record",
		sidebar: { label: "Records" },
		type: "record"
	},
	report: {
		Config: ReportFieldConfig,
		defaultOptions: {
			displayLabel: "Report",
			formLabel: "Report"
		},
		DisplayLayout: ReportFieldDisplay,
		FormLayout: ReportFieldForm,
		idPrefix: "report",
		sidebar: { label: "Report" },
		type: "report"
	},
	select: {
		Config: SelectFieldConfig,
		defaultOptions: {
			displayLabel: "Dropdown",
			formLabel: "Dropdown",
			options: [{ label: "Option 1" }, { label: "Options 2" }]
		},
		DisplayLayout: SelectFieldDisplay,
		FormLayout: SelectFieldForm,
		idPrefix: "select",
		sidebar: { label: "Dropdown" },
		type: "select"
	},
	signature: {
		Config: SignatureFieldConfig,
		defaultOptions: {
			displayLabel: "Signature",
			formLabel: "Signature"
		},
		DisplayLayout: SignatureFieldDisplay,
		FormLayout: SignatureFieldForm,
		idPrefix: "signature",
		sidebar: { label: "Signature" },
		type: "signature"
	},
	text: {
		Config: TextFieldConfig,
		defaultOptions: {
			displayLabel: "Text",
			formLabel: "Text"
		},
		DisplayLayout: TextFieldDisplay,
		FormLayout: TextFieldForm,
		idPrefix: "text",
		sidebar: { label: "Text" },
		type: "text"
	},
	textarea: {
		Config: TextareaFieldConfig,
		defaultOptions: {
			displayLabel: "Text Block",
			formLabel: "Text Block"
		},
		DisplayLayout: TextareaFieldDisplay,
		FormLayout: TextareaFieldForm,
		idPrefix: "textarea",
		sidebar: { label: "Text Block" },
		type: "textarea"
	},
	user: {
		Config: UserFieldConfig,
		defaultOptions: {
			displayLabel: "Users",
			formLabel: "Users"
		},
		DisplayLayout: UserFieldDisplay,
		FormLayout: UserFieldForm,
		idPrefix: "user",
		sidebar: { label: "Users" },
		type: "user"
	}
};
//#endregion
export { formBuilderFieldsByType };

//# sourceMappingURL=index.js.map